import React from 'react'
import Navbar from '../../Components/Navbar'
import HeroSection from '../Hero'
import WhyChooseUs from '../WhyUs'
import ThirdSec from '../ThirdSec'
import TarCust from '../TarCust'
import Services from '../Services'
import Commitement from '../Commitement'
import Contact from '../Contact'
import Footer from '../../Components/Footer'
import wp from "../../assests/Footer/wp.png"
import  "./style.css"

export default function Home() {
  return (
    <>
      <Navbar />
      <HeroSection />
      <WhyChooseUs />
      <ThirdSec />
      <TarCust />
      <Commitement />
      <Services />
      <Contact />
      <a
        href="https://wa.me/6589068099?text=Hi%20I'm%20interested%20in%20your%20services"
        className="whatsapp-button"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img src={wp} alt="Chat on WhatsApp"  />
      </a>

      <Footer />
    </>
  )
}
